import { render, staticRenderFns } from "./OrderPrint.vue?vue&type=template&id=27aaa940&scoped=true&"
import script from "./OrderPrint.vue?vue&type=script&lang=ts&"
export * from "./OrderPrint.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPrint.vue?vue&type=style&index=0&id=27aaa940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aaa940",
  null
  
)

export default component.exports